import apiClient from './apiClient';

const ticketService = {
  // Ticket Services
  getAllTickets: async () => {
    const response = await apiClient.post('/ticket/GetAllTickets');
    return response.data?.Data?.Items || [];
  },

  getTicketById: async (id) => {
    const response = await apiClient.post('/ticket/GetTicketById', null, { params: { id } });
    return response.data.Data;
  },

  getTicketsByUserId: async (userId) => {
    const response = await apiClient.post('/ticket/GetTicketsByUserId', null, { params: { userId } });
    return response.data?.Data?.Items || [];
  },

  getTicketsByStatusId: async (statusId) => {
    const response = await apiClient.post('/ticket/GetTicketsByStatusId', null, { params: { statusId } });
    return response.data?.Data?.Items || [];
  },

  getTicketsByTypeId: async (typeId) => {
    const response = await apiClient.post('/ticket/GetTicketsByTypeId', null, { params: { typeId } });
    return response.data?.Data?.Items || [];
  },

  addTicket: async (ticket) => {
    const response = await apiClient.post('/ticket/AddTicket', ticket);
    return response.data;
  },

  updateTicket: async (ticket) => {
    const response = await apiClient.post('/ticket/UpdateTicket', ticket);
    return response.data;
  },

  deleteTicket: async (id) => {
    const response = await apiClient.post('/ticket/DeleteTicket', null, { params: { id } });
    return response.data;
  },

  changeTicketStatus: async (ticketId, statusId) => {
    const response = await apiClient.post('/ticket/ChangeTicketStatus', null, { 
      params: { ticketId, statusId } 
    });
    return response.data;
  },

  // TicketType Services
  getAllTicketTypes: async () => {
    const response = await apiClient.post('/ticket/GetAllTicketTypes');
    return response.data?.Data?.Items || [];
  },

  getTicketTypeById: async (id) => {
    const response = await apiClient.post('/ticket/GetTicketTypeById', null, { params: { id } });
    return response.data.Data;
  },

  addTicketType: async (ticketType) => {
    const response = await apiClient.post('/ticket/AddTicketType', ticketType);
    return response.data;
  },

  updateTicketType: async (ticketType) => {
    const response = await apiClient.post('/ticket/UpdateTicketType', ticketType);
    return response.data;
  },

  deleteTicketType: async (id) => {
    const response = await apiClient.post('/ticket/DeleteTicketType', null, { params: { id } });
    return response.data;
  },

  // TicketStatus Services
  getAllTicketStatuses: async () => {
    const response = await apiClient.post('/ticket/GetAllTicketStatuses');
    return response.data?.Data?.Items || [];
  },

  getTicketStatusById: async (id) => {
    const response = await apiClient.post('/ticket/GetTicketStatusById', null, { params: { id } });
    return response.data.Data;
  },

  addTicketStatus: async (ticketStatus) => {
    const response = await apiClient.post('/ticket/AddTicketStatus', ticketStatus);
    return response.data;
  },

  updateTicketStatus: async (ticketStatus) => {
    const response = await apiClient.post('/ticket/UpdateTicketStatus', ticketStatus);
    return response.data;
  },

  deleteTicketStatus: async (id) => {
    const response = await apiClient.post('/ticket/DeleteTicketStatus', null, { params: { id } });
    return response.data;
  }
};

export default ticketService;